import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, NavigationExtras } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services';
import { constants } from '../constants';
@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.activeSession()) {
      return true;
    }

    this.router.navigate([constants.DEFAULT_ROUTE], this.getReturnUrl(state.url));
    return false;
  }

  getReturnUrl(url?: string): NavigationExtras | undefined {
    if (!url || url === constants.HOME_ROUTE) {
      return undefined;
    }

    return {
      queryParams: {
        returnUrl: url,
      },
    };
  }
}
